import {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {stringUtils} from 'front-onceforall-core';
import {interventionRole} from '../../utils/constant';

export class ProjectRoleForm extends Component {
  render() {
    return (
      <>
        <p>
          {stringUtils.getStrongs(I18n.t('project.roleForm.notice', {
            organisationName: this.props.organisationName
          }))}
        </p>
        <div className="row">
          <div className="col-lg-4">
            <div
              className="box flex-container column space-between"
              style={{height: '100%'}}
            >
              <div className="flex-container column">
                <h3 className="active"><Translate value="intervention.role.CLIENT"/></h3>
                <p>{stringUtils.getStrongs(I18n.t('project.roleForm.client.intro'))}</p>
                <ul className="mb-5 mt-0">
                  <li><Translate value="project.roleForm.client.firstPoint"/></li>
                  <li><Translate value="project.roleForm.client.secondPoint"/></li>
                  <li><Translate value="project.roleForm.client.thirdPoint"/></li>
                </ul>
              </div>
              <div>
                <button
                  type="button"
                  className="large primary"
                  onClick={() => this.props.onSelectRole(interventionRole.CLIENT)}
                >
                  <Translate value="project.roleForm.choose"/>
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div
              className="box flex-container column space-between"
              style={{height: '100%'}}
            >
              <div className="flex-container column">
                <h3 className="active"><Translate value="intervention.role.PROJECT_MANAGER_CLIENT"/></h3>
                <p>{stringUtils.getStrongs(I18n.t('project.roleForm.projectManagerClient.intro'))}</p>
                <ul className="mb-5 mt-0">
                  <li><Translate value="project.roleForm.projectManagerClient.firstPoint"/></li>
                  <li><Translate value="project.roleForm.projectManagerClient.secondPoint"/></li>
                  <li><Translate value="project.roleForm.projectManagerClient.thirdPoint"/></li>
                </ul>
              </div>
              <div>
                <button
                  type="button"
                  className="large primary"
                  onClick={() => this.props.onSelectRole(interventionRole.PROJECT_MANAGER_CLIENT)}
                >
                  <Translate value="project.roleForm.choose"/>
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div
              className="box flex-container column space-between"
              style={{height: '100%'}}
            >
              <div className="flex-container column">
                <h3 className="active"><Translate value="intervention.role.GENERAL_CONTRACTOR"/></h3>
                <p>{stringUtils.getStrongs(I18n.t('project.roleForm.generalContractor.intro'))}</p>
                <ul className="mb-5 mt-0">
                  <li><Translate value="project.roleForm.generalContractor.firstPoint"/></li>
                  <li><Translate value="project.roleForm.generalContractor.secondPoint"/></li>
                  <li><Translate value="project.roleForm.generalContractor.thirdPoint"/></li>
                </ul>
              </div>
              <div>
                <button
                  type="button"
                  className="large primary"
                  onClick={() => this.props.onSelectRole(interventionRole.GENERAL_CONTRACTOR)}
                >
                  <Translate value="project.roleForm.choose"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

ProjectRoleForm.propTypes = {
  organisationName: PropTypes.string.isRequired,
  onSelectRole: PropTypes.func.isRequired
};

export default ProjectRoleForm;
